export const routes = {
  home: "/",
  user: {
    home: "/user",
    userProfile: (userId: number | string) => `/user/${userId}`,
    register: "/user/register",
    registerEmail: "/user/register/email",
    registerSocial: "/user/register/social-media",
    forgotPassword: "/user/forgot-password",
    resendEmail: "/user/resend-email",
    login: "/user/login",
    logout: "/user/logout",
    affiliate: (userId: string | number) => `/user/affiliate`,
  },
  blog: {
    list: "/blog",
    blogPost: (slug: string) => `/blog/${slug}`,
  },
};

export default routes;
